import { fork, take, select, call, put } from "redux-saga/effects";
import {
  ADD_GROUP,
  ADD_GROUP_FAIL,
  ADD_GROUP_SUCCESS,
  SAVE_GROUP,
  SAVE_GROUP_FAIL,
  SAVE_GROUP_SUCCESS,
  VALIDATE_FORM_ERROR,
  ADD_GROUP_REQUEST,
  SAVE_GROUP_REQUEST,
  END_ACTION,
} from "./actionTypes";
import { GroupData } from "./reducer";

export function validateForm(groupData: GroupData) {
  // Test validate return ok always
  const error = [];
  let ok = true;

  if (!groupData.group_type) {
    error.push("Group Type is required.");
  }

  if (!groupData.group_name) {
    error.push("Group Name is required.");
  }

  if (!groupData.group_key && groupData.group_type === "project") {
    error.push("Group Key is required.");
  }

  if (!groupData.project && groupData.group_type === "site") {
    error.push("Project is required.");
  }

  if (error.length > 0) {
    ok = false;
  }

  return {
    ok,
    error,
  };
}

export function* executeGroupAction(
  response: any,
  func: any,
  user: any,
  auth: any
) {
  // NOTE: This only handles client-side validation
  if (response.ok) {
    // call add user asynchronously
    yield fork(func, user, auth);
  } else {
    // Return errors in form - Better to use redux form
    yield put({ type: VALIDATE_FORM_ERROR, error: response.error });
  }
}

// Our watcher Saga:
// const getCreateUserFormValues = state => state.form.createUser.values
const getGroupFormValues = (state: Insite.AppState) =>
  state.groups.group_form_data;
const getAuthToken = (state: Insite.AppState) => state.auth.user.token;

function* addGroup(row: GroupData, token: string) {
  const action: any = {
    types: [ADD_GROUP, ADD_GROUP_SUCCESS, ADD_GROUP_FAIL],
    promise: (client: any) =>
      client.post("/group", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          group_type: row.group_type,
          group_name: row.group_name,
          group_key: row.group_key,
          project: row.project,
        },
      }),
  };

  yield put(action);
}

export function* saveGroup(row: GroupData, token: string): Generator<any, any, any> {
  const action: any = yield {
    types: [SAVE_GROUP, SAVE_GROUP_SUCCESS, SAVE_GROUP_FAIL],
    // replace with edit group url
    promise: (client: any) =>
      client.post(`/group`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          group_id: Number(row.group_id),
          group_key: row.group_key,
          group_name: row.group_name,
          group_type: row.group_type,
        },
      }),
  };

  yield put(action);
}

export function* saveGroupFlow(): Generator<any, any, any> {
  while (true) {
    // Wait for start of cycle action
    const action = yield take([ADD_GROUP_REQUEST, SAVE_GROUP_REQUEST]);
    const func = action.type === ADD_GROUP_REQUEST ? addGroup : saveGroup;

    // Get values from form - Better to use redux form
    const groupData = yield select(getGroupFormValues);
    const token = yield select(getAuthToken);

    // Validate - Better to do this with redux form
    const response = yield call(validateForm, groupData);

    // Save User task
    yield fork(executeGroupAction, response, func, groupData, token);

    // Wait for end of cycle action
    yield take([
      ADD_GROUP_SUCCESS,
      SAVE_GROUP_SUCCESS,
      ADD_GROUP_FAIL,
      SAVE_GROUP_FAIL,
      END_ACTION,
      VALIDATE_FORM_ERROR,
    ]);
  }
}
